<template>
  <div class="maxi-puntos-container">
    <h1 class="titulo">Productos MaxiPuntos</h1>
    
    <!-- Menú de opciones tipo card -->
    <div class="mini-menu">
      <div class="mini-card" @click="abrirModal('que')">
        <i class="mdi mdi-information"></i>
        ¿Qué son MaxiPuntos?
      </div>
      <div class="mini-card" @click="abrirModal('como-obtener')">
        <i class="mdi mdi-star-plus-outline"></i>
        ¿Cómo obtenerlos?
      </div>
      <div class="mini-card" @click="abrirModal('como-reclamar')">
        <i class="mdi mdi-gift-outline"></i>
        ¿Cómo reclamarlos?
      </div>
      <div class="mini-card" @click="abrirModal('consulta')">
        <i class="mdi mdi-account-search"></i>
        Consulta aquí MaxiPuntos
      </div>
    </div>

    <!-- Modal general -->
    <div v-if="modalVisible" class="modal-fondo" @click.self="modalVisible=false">
      <div class="modal-maxi">
        <button class="cerrar-modal" @click="modalVisible=false"><i class="mdi mdi-close"></i></button>
        <div v-if="modalTipo==='que'">
          <h2>¿Qué son MaxiPuntos?</h2>
          <p>
            Son puntos que acumulas por cada compra en nuestro sistema. ¡Entre más compras, más puntos para canjear por productos exclusivos!
          </p>
        </div>
        <div v-else-if="modalTipo==='como-obtener'">
          <h2>¿Cómo obtener MaxiPuntos?</h2>
          <p>
            Cada vez que realices una compra, se suman automáticamente MaxiPuntos a tu cuenta. Por cada $1.000 en compras, recibes 1 punto. 
          </p>
        </div>
        <div v-else-if="modalTipo==='como-reclamar'">
          <h2>¿Cómo reclamar tus premios?</h2>
          <p class="texto-modal">
            Reclamar tus premios es muy fácil:
          </p>
          <ol class="pasos-reclamo">
            <li>Selecciona el producto que quieres reclamar.</li>
            <li>Dale clic al botón <b>Reclamar</b>.</li>
            <li>Escribe tu número de teléfono para validar tus MaxiPuntos.</li>
          </ol>
          <p class="texto-modal nota-reclamo">
            Listo. Ya puedes reclamar tu premio con tu asesor o dirigiéndote al punto de venta.
          </p>
        </div>
        <div v-else-if="modalTipo==='consulta'">
          <h2>Consulta tus MaxiPuntos</h2>
          <input
            v-model="telefonoConsulta"
            @input="soloNumeros"
            class="input-telefono"
            placeholder="Número de teléfono"
            maxlength="16"
          />
          <button class="boton-consulta" @click="consultarPuntos">Consultar</button>
          <p v-if="errorConsulta" class="error">{{ errorConsulta }}</p>
          <p v-if="puntosCliente !== null">
            <span v-if="puntosCliente === 0">No hay aun puntos.</span>
            <span v-else>Tienes {{ puntosCliente }} MaxiPuntos.</span>
          </p>
        </div>
      </div>
    </div>

    <!-- Tu listado de productos -->
    <div class="puntos-lista">
      <div class="punto-card" v-for="p in productos" :key="p.id">
        <div v-if="p.foto" class="punto-foto">
          <img
            :src="p.foto"
            :alt="`Foto de ${p.nombre}`"
            @click="abrirImagen(p.foto)"
          />
        </div>
        <div class="punto-body">
          <div class="punto-nombre">
            {{ p.nombre }}
            <span v-if="p.talla" class="punto-talla">{{ formatearTalla(p.talla) }}</span>
          </div>
          <div class="punto-desc">{{ p.descripcion }}</div>
          <div class="punto-meta" v-if="p.codigo">
            <span class="punto-codigo">Ref: {{ p.codigo }}</span>
          </div>
        </div>
        <div class="punto-footer">
          <span class="puntos">
            <svg style="width: 1.3em; vertical-align: -0.15em; margin-right: 3px" viewBox="0 0 24 24">
              <path fill="#FFD700" d="M12,17.27L18.18,21l-1.64-7.03L22,9.24l-7.19-.61L12,2 9.19,8.63 2,9.24l5.46,4.73L5.82,21z"/>
            </svg>
            <b>{{ p.valor_puntos.toLocaleString("es-CO") }}</b> puntos
          </span>
          <button class="boton-reclamar" type="button" @click="iniciarReclamo(p)">
            Reclamar
          </button>
        </div>
      </div>
    </div>

    <!-- Botón Cargar Más -->
    <div class="cargar-mas-container" v-if="hayMas">
      <button 
        class="boton-cargar-mas" 
        :disabled="cargando" 
        @click="cargar"
      >
        <template v-if="cargando">
          <i class="mdi mdi-loading mdi-spin"></i> Cargando...
        </template>
        <template v-else>
          Cargar más productos
        </template>
      </button>
    </div>
    <div class="no-hay-mas" v-if="!hayMas && productos.length > 0">
      No hay más productos para mostrar
    </div>

    <div v-if="reclamoVisible" class="modal-fondo" @click.self="cerrarReclamo">
      <div class="modal-maxi modal-reclamo">
        <button class="cerrar-modal" @click="cerrarReclamo">
          <i class="mdi mdi-close"></i>
        </button>

        <template v-if="reclamoPaso === 'telefono'">
          <h2>Reclamar {{ productoReclamo ? productoReclamo.nombre : "" }}</h2>
          <p class="texto-modal">
            Ingresa tu número de teléfono para validar tus MaxiPuntos.
          </p>
          <input
            v-model="telefonoReclamo"
            @input="soloNumerosReclamo"
            class="input-telefono"
            placeholder="Número de teléfono"
            maxlength="16"
          />
          <p v-if="errorReclamo" class="error">{{ errorReclamo }}</p>
          <div class="acciones-reclamo">
            <button
              class="boton-consulta"
              :disabled="procesandoReclamo"
              @click="validarReclamo"
            >
              {{ procesandoReclamo ? "Validando..." : "Continuar" }}
            </button>
            <button class="boton-secundario" type="button" @click="cerrarReclamo">
              Cancelar
            </button>
          </div>
        </template>

        <template v-else-if="reclamoPaso === 'confirmacion'">
          <h2>¿Deseas reclamar este producto?</h2>
          <p class="texto-modal">
            Se descontarán <b>{{ productoReclamo.valor_puntos.toLocaleString("es-CO") }}</b> puntos.
            Sus nuevos puntos serán <b>{{ puntosRestantes.toLocaleString("es-CO") }}</b>.
          </p>
          <p class="texto-modal nombre-cliente">
            Cliente: <b>{{ clienteReclamo.nombre }}</b> - {{ clienteReclamo.telefono }}
          </p>
          <p v-if="errorReclamo" class="error">{{ errorReclamo }}</p>
          <div class="acciones-reclamo">
            <button
              class="boton-consulta"
              :disabled="procesandoReclamo"
              @click="confirmarReclamo"
            >
              {{ procesandoReclamo ? "Procesando..." : "Aceptar" }}
            </button>
            <button class="boton-secundario" type="button" @click="cerrarReclamo">
              Cancelar
            </button>
          </div>
        </template>

        <template v-else-if="reclamoPaso === 'resultado'">
          <h2>Reclamo registrado</h2>
          <p class="texto-modal">
            ¡Listo! Se descontaron {{ productoReclamo.valor_puntos.toLocaleString("es-CO") }} puntos.
            Tu nuevo saldo es {{ puntosRestantes.toLocaleString("es-CO") }} MaxiPuntos.
          </p>
          <div class="acciones-reclamo">
            <button class="boton-consulta" type="button" @click="cerrarReclamo">
              Cerrar
            </button>
          </div>
        </template>
      </div>
    </div>

    <div
      v-if="imagenSeleccionada"
      class="modal-imagen"
      @click.self="cerrarImagen"
    >
      <button
        class="cerrar-imagen"
        type="button"
        @click="cerrarImagen"
        aria-label="Cerrar imagen ampliada"
      >
        <i class="mdi mdi-close"></i>
      </button>
      <img :src="imagenSeleccionada" alt="Producto MaxiPuntos ampliado" />
    </div>
  </div>
</template>


<script>
import HttpService from "@/Servicios/HttpService";
export default {
  name: "MaxiPuntos",
  data() {
    return {
      productos: [],
      ordenAsc: true,
      pagina: 1,
      porPagina: 20,
      cargando: false,
      hayMas: true,
      modalVisible: false,
      modalTipo: null,
      telefonoConsulta: "",
      puntosCliente: null,
      errorConsulta: "",
      imagenSeleccionada: null,
      reclamoVisible: false,
      productoReclamo: null,
      telefonoReclamo: "",
      clienteReclamo: null,
      puntosRestantes: 0,
      errorReclamo: "",
      procesandoReclamo: false,
      reclamoPaso: "telefono",
    };
  },
  methods: {
    alternarOrden() {
      this.ordenAsc = !this.ordenAsc;
      this.productos = [];
      this.pagina = 1;
      this.hayMas = true;
      this.cargar();
    },
    cargar() {
      if (this.cargando || !this.hayMas) return;
      this.cargando = true;
      const params = {
        pagina: this.pagina,
        por_pagina: this.porPagina,
        orden: this.ordenAsc ? 'ASC' : 'DESC'
      };
      const consulta = new URLSearchParams(params).toString();
      HttpService.obtener(`maxipuntos.php?${consulta}`).then((res) => {
        const nuevos = (res || []).map((producto) => ({
          ...producto,
          nombre: producto.nombre || "",
          descripcion: producto.descripcion || "",
          valor_puntos: Number(producto.valor_puntos) || 0,
          foto: this.obtenerFotoProducto(producto),
        }));
        
        const unicos = nuevos.filter(
          (nuevo) => !this.productos.some((producto) => producto.id === nuevo.id)
        );
        this.productos = [...this.productos, ...unicos];
        this.pagina++;
        if (nuevos.length < this.porPagina) {
          this.hayMas = false;
        }
      }).finally(() => {
        this.cargando = false;
      });
    },
    obtenerFotoProducto(producto) {
      const imagenes = producto.producto_imagenes || [];

      if (producto.imagenRelacionada) {
        const relacionada = imagenes.find(
          (img) => String(img.slot) === String(producto.imagenRelacionada)
        );
        if (relacionada && relacionada.ruta) {
          return this.normalizarFoto(relacionada.ruta);
        }
      }

      if (producto.foto) {
        return this.normalizarFoto(producto.foto);
      }

      const primera = imagenes.find((img) => img && img.ruta);
      return primera ? this.normalizarFoto(primera.ruta) : null;
    },
    normalizarFoto(ruta) {
      if (!ruta) return null;

      if (ruta.startsWith("http")) {
        return ruta;
      }

      if (ruta.includes("../api/")) {
        return ruta.replace("../api/", "https://maxica.com.co/ximena/api/");
      }

      const limpia = ruta.replace(/^\.\/?/, "");
      return `https://maxica.com.co/ximena/api/${limpia}`;
    },
    formatearTalla(talla) {
      const texto = String(talla || "").trim();
      if (!texto) return "";
      return /^talla\s/i.test(texto) ? texto : `Talla ${texto}`;
    },
    abrirModal(tipo) {
      this.modalTipo = tipo;
      this.modalVisible = true;
      if (tipo === "consulta") {
        this.telefonoConsulta = "";
        this.puntosCliente = null;
        this.errorConsulta = "";
      }
    },
    abrirModalDesdeRuta() {
      if (this.$route.query.modal === "consulta") {
        this.abrirModal("consulta");
      }
    },
    normalizarTelefono(telefono) {
      let digitos = String(telefono || "").replace(/\D/g, "");
      if (digitos.length > 10 && digitos.startsWith("57")) {
        digitos = digitos.slice(2);
      }
      if (digitos.length > 10) {
        digitos = digitos.slice(-10);
      }
      return digitos.slice(0, 10);
    },
    soloNumeros() {
      this.telefonoConsulta = this.normalizarTelefono(this.telefonoConsulta);
    },
    consultarPuntos() {
      this.errorConsulta = "";
      this.puntosCliente = null;
      if (!/^3\d{9}$/.test(this.telefonoConsulta)) {
        this.errorConsulta = "Ingresa un número de teléfono válido";
        return;
      }
      const payload = { accion: "consultar_puntos", telefono: this.telefonoConsulta };
      HttpService.obtenerConConsultas("clientes.php", payload)
        .then((res) => {
          this.puntosCliente = res && res.puntos ? parseInt(res.puntos) : 0;
        })
        .catch(() => {
          this.errorConsulta = "Error al consultar puntos";
        });
    },
    abrirImagen(foto) {
      this.imagenSeleccionada = foto;
      document.body.style.overflow = "hidden";
    },
    cerrarImagen() {
      this.imagenSeleccionada = null;
      document.body.style.overflow = "";
    },
    iniciarReclamo(producto) {
      this.productoReclamo = producto;
      this.reclamoVisible = true;
      this.telefonoReclamo = "";
      this.clienteReclamo = null;
      this.puntosRestantes = 0;
      this.errorReclamo = "";
      this.procesandoReclamo = false;
      this.reclamoPaso = "telefono";
      document.body.style.overflow = "hidden";
    },
    cerrarReclamo() {
      this.reclamoVisible = false;
      this.productoReclamo = null;
      this.telefonoReclamo = "";
      this.clienteReclamo = null;
      this.puntosRestantes = 0;
      this.errorReclamo = "";
      this.procesandoReclamo = false;
      this.reclamoPaso = "telefono";
      document.body.style.overflow = "";
    },
    soloNumerosReclamo() {
      this.telefonoReclamo = this.normalizarTelefono(this.telefonoReclamo);
    },
    validarReclamo() {
      this.errorReclamo = "";
      if (!this.productoReclamo) {
        this.errorReclamo = "Selecciona un producto";
        return;
      }
      if (!/^3\d{9}$/.test(this.telefonoReclamo)) {
        this.errorReclamo = "Ingresa un número de teléfono válido";
        return;
      }
      this.procesandoReclamo = true;
      const payload = {
        accion: "validar_reclamo",
        telefono: this.telefonoReclamo,
        idTalla: this.productoReclamo.id,
      };
      HttpService.obtenerConConsultas("clientes.php", payload)
        .then((res) => {
          if (!res || !res.exito) {
            this.errorReclamo = res && res.mensaje ? res.mensaje : "No fue posible validar el reclamo";
            return;
          }
          this.clienteReclamo = res.cliente;
          this.puntosRestantes = res.puntosRestantes;
          this.reclamoPaso = "confirmacion";
        })
        .catch(() => {
          this.errorReclamo = "Error al validar el reclamo";
        })
        .finally(() => {
          this.procesandoReclamo = false;
        });
    },
    confirmarReclamo() {
      if (!this.productoReclamo || !this.clienteReclamo) {
        this.errorReclamo = "Información incompleta para el reclamo";
        return;
      }
      this.errorReclamo = "";
      this.procesandoReclamo = true;
      const payload = {
        accion: "confirmar_reclamo",
        telefono: this.clienteReclamo.telefono,
        idTalla: this.productoReclamo.id,
        foto: this.productoReclamo.foto,
      };
      HttpService.obtenerConConsultas("clientes.php", payload)
        .then((res) => {
          if (!res || !res.exito) {
            this.errorReclamo = res && res.mensaje ? res.mensaje : "No fue posible registrar el reclamo";
            return;
          }
          if (res.cliente) {
            this.clienteReclamo = res.cliente;
          }
          this.puntosRestantes = res.puntosRestantes;
          this.reclamoPaso = "resultado";
          if (this.telefonoConsulta === this.clienteReclamo.telefono) {
            this.puntosCliente = this.puntosRestantes;
          }
          if (res.producto && typeof res.producto.existencia !== "undefined") {
            const existencia = Number(res.producto.existencia);
            if (existencia <= 0) {
              this.productos = this.productos.filter(
                (producto) => producto.id !== this.productoReclamo.id
              );
            } else {
              this.productos = this.productos.map((producto) =>
                producto.id === this.productoReclamo.id
                  ? { ...producto, existencia }
                  : producto
              );
            }
          }
        })
        .catch(() => {
          this.errorReclamo = "Error al registrar el reclamo";
        })
        .finally(() => {
          this.procesandoReclamo = false;
        });
    },
  },
  created() {
    this.cargar();
    this.abrirModalDesdeRuta();
  },
  watch: {
    "$route.query.modal"() {
      this.abrirModalDesdeRuta();
    },
  },
  beforeDestroy() {
    document.body.style.overflow = "";
  },
};
</script>


<style scoped>
.maxi-puntos-container {
  padding: 60px 0.5rem 2rem 0.5rem;
  background: #eaf3ff;
  min-height: 100vh;
}
.titulo {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 1.2rem;
  font-weight: bold;
  color: #253052;
}
/* --- MINI MENU --- */
.mini-menu {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 2.2rem;
}
.mini-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 6px #b4cff954;
  padding: 0.7em 1.3em;
  font-size: 1em;
  color: #2a3646;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5em;
  transition: box-shadow .13s, transform .13s;
  user-select: none;
}
.mini-card:hover {
  background: #f3f7ff;
  box-shadow: 0 6px 18px #b4cff996;
  transform: translateY(-2px) scale(1.02);
}
.mdi { font-size: 1.25em; }
/* --- MODAL --- */
.modal-fondo {
  position: fixed;
  z-index: 1500;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(38,51,78,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-maxi {
  background: #fff;
  border-radius: 18px;
  padding: 2rem 2rem 1.5rem 2rem;
  max-width: 400px;
  width: 95vw;
  position: relative;
  box-shadow: 0 4px 24px #b4cff9a1;
  animation: popin .13s cubic-bezier(.31,1.48,.59,1.03);
}
@keyframes popin { from {transform: scale(.88);} to {transform: scale(1);} }
.cerrar-modal {
  position: absolute;
  top: 0.7em;
  right: 0.7em;
  border: none;
  background: transparent;
  font-size: 1.5em;
  cursor: pointer;
  color: #a3a3a3;
  transition: color .13s;
}
.cerrar-modal:hover { color: #ff4433; }
.modal-maxi h2 {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 0.8em;
  color: #2269a7;
}
.modal-maxi p, .modal-maxi ul, .modal-maxi ol { font-size: 1.03em; }
.pasos-reclamo {
  margin: 0 0 1rem 0;
  padding-left: 1.25rem;
  color: #2a3646;
}
.pasos-reclamo li {
  margin-bottom: 0.55rem;
  line-height: 1.35;
}
.nota-reclamo {
  background: #f4f9ff;
  border-radius: 10px;
  padding: 0.75rem 0.85rem;
  margin-bottom: 0;
}
.nota { font-size: 0.92em; color: #a2a2a2; }
.input-telefono {
  width: 100%;
  padding: 0.5em;
  border: 1px solid #c2c2c2;
  border-radius: 8px;
  margin-bottom: 1em;
}
.boton-consulta {
  background: #2269a7;
  color: #fff;
  border: none;
  padding: 0.5em 1em;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 1em;
}
.boton-consulta:hover { background: #1b568b; }
.error { color: #ff4433; margin-top: 0.5em; }
@media (max-width: 700px) {
  .mini-menu {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.7em;
    justify-items: center;
  }
  .mini-card {
    width: 98%;
    min-width: unset;
    margin-right: 0;
  }
}

.puntos-lista {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;
}
.punto-card {
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 3px 14px 0 #b4cff9a1;
  padding: 1.4rem 1.5rem 1.3rem 1.5rem;
  width: min(320px, 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.14s;
  position: relative;
}
.punto-card:hover {
  transform: translateY(-6px) scale(1.025);
  box-shadow: 0 8px 24px 0 #b4cff9fa;
}
.punto-foto {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}
.punto-foto img {
  width: 100%;
  max-width: 240px;
  max-height: 220px;
  object-fit: contain;
  border-radius: 18px;
  background: #f5f7fb;
  padding: 0.4rem;
  cursor: zoom-in;
  transition: transform 0.18s ease;
  box-shadow: inset 0 0 0 1px #e3ecff;
}
.punto-foto img:hover {
  transform: scale(1.03);
}
.punto-nombre {
  font-weight: bold;
  font-size: 1.12em;
  margin-bottom: 0.5em;
  text-align: center;
  color: #2a3646;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: center;
}
.punto-talla {
  background: #eff3ff;
  color: #3556a2;
  border-radius: 8px;
  padding: 2px 8px;
  font-size: 0.85em;
  font-weight: 600;
}
.punto-desc {
  font-size: 0.97em;
  color: #8b8b8b;
  margin-bottom: 1.4em;
  text-align: center;
  min-height: 32px;
}
.punto-meta {
  margin-top: -6px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 0.9em;
  color: #4b5567;
}
.punto-codigo,
.punto-slot {
  background: #f5f7fb;
  border-radius: 6px;
  padding: 3px 8px;
}
.punto-footer {
  margin-top: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
}
.puntos {
  background: #fff6e3;
  color: #d46a00;
  border-radius: 14px;
  font-size: 1.11em;
  padding: 0.38em 1em;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  box-shadow: 0 1px 6px 0 #ffd7826d;
}
.boton-reclamar {
  background: #2269a7;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 0.4em 1.1em;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s ease, transform 0.18s ease;
}
.boton-reclamar:hover {
  background: #1b568b;
  transform: translateY(-1px);
}
.modal-reclamo {
  max-width: 440px;
}
.texto-modal {
  font-size: 1em;
  margin-bottom: 1rem;
  color: #2a3646;
}
.nombre-cliente {
  background: #f4f9ff;
  padding: 0.6rem 0.8rem;
  border-radius: 10px;
}
.acciones-reclamo {
  display: flex;
  gap: 0.7rem;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.acciones-reclamo .boton-consulta {
  margin-bottom: 0;
}
.boton-secundario {
  background: #f0f3f8;
  color: #2a3646;
  border: none;
  border-radius: 10px;
  padding: 0.45em 1.1em;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.18s ease;
}
.boton-secundario:hover {
  background: #e2e7ef;
}
@media (max-width: 800px) {
  .puntos-lista {
    gap: 0.6rem;
  }
  .punto-card {
    width: min(92vw, 360px);
    padding: 1.1rem 0.9rem 1rem 0.9rem;
  }
}

@media (max-width: 480px) {
  .punto-card {
    border-radius: 20px;
  }
  .punto-foto img {
    max-width: 260px;
  }
}

.modal-imagen {
  position: fixed;
  inset: 0;
  background: rgba(12, 24, 48, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1600;
  padding: 1.5rem;
}

.modal-imagen img {
  max-width: min(90vw, 540px);
  max-height: 85vh;
  border-radius: 20px;
  object-fit: contain;
  background: #ffffff;
  padding: 0.75rem;
  box-shadow: 0 18px 45px rgba(15, 35, 70, 0.45);
}

.cerrar-imagen {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  background: rgba(255, 255, 255, 0.85);
  border: none;
  border-radius: 999px;
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  font-size: 1.6rem;
  cursor: pointer;
  transition: background 0.18s ease;
}

.cerrar-imagen:hover {
  background: #ffffff;
}

.cargar-mas-container {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  padding-bottom: 2rem;
}

.boton-cargar-mas {
  background: #2269a7;
  color: #fff;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(34, 105, 167, 0.3);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.boton-cargar-mas:hover:not(:disabled) {
  background: #1b568b;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(34, 105, 167, 0.4);
}

.boton-cargar-mas:disabled {
  background: #a2b9d0;
  cursor: not-allowed;
  box-shadow: none;
}

.no-hay-mas {
  text-align: center;
  color: #6c757d;
  margin-top: 1rem;
  margin-bottom: 2rem;
  font-style: italic;
}
</style>
